export default __webpack_public_path__ + "static/media/ic_cancel_red.a82bab85.svg";